import { defineEntity, custom } from './_helpers.js';

export default defineEntity(
    'audit',
    {
        'finding.created': custom({ scope: 'state' }),
    },
    { includeDefaultLifecycle: false },
);
